import React from "react";
import { Row, Col } from "antd";
import { Modal } from "../../../core";
import { Input, Typography, Button, Loading } from "../../../core";
import styled from "styled-components";
import { Form } from "antd";
import { MixStyle } from "../../../styles";
import { updateClothQuality } from "../../../helper/utils/api/settings";
const Notify_Utils = require("../../../helper/utils/Notification");

const layout = {
  labelCol: {
    span: 24,
  },
  wrapperCol: {
    span: 24,
  },
};

const StyledForm = styled(Form)`
  label {
    ${MixStyle.Label};
  }
`;

const AddYarnQuality = ({
  editClothQualityModal,
  closeModal,
  getClothQualities,
  dataToEdit,
}) => {
  const [form] = Form.useForm();

  const [updatedValue, setUpdatedValue] = React.useState({});
  const [formInitialValue, setFormInitialValue] = React.useState({});
  const [isLoading, setIsLoading] = React.useState(false);

  React.useEffect(() => {
    setFormInitialValue(dataToEdit);
  }, [dataToEdit]);

  const onFinish = async (fieldsValue) => {
    setIsLoading(true);
    await updateClothQualityHandler();
    setIsLoading(false);
  };

  const updateClothQualityHandler = async () => {
    try {
      let clothQualityIdToEdit = formInitialValue._id;
      let response = await updateClothQuality(
        clothQualityIdToEdit,
        updatedValue
      );
      Notify_Utils.openNotificationWithIcon("success", response.data.message);
      closeModalHandler();
      getClothQualities();
    } catch (error) {
      Notify_Utils.openNotificationWithIcon(
        "error",
        "Error While update yarn quality"
      );
      console.log("error while update", error);
    }
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const onValuesChange = (changedValues, valuse) => {
    console.log(changedValues);
    setUpdatedValue((prev) => ({ ...prev, ...changedValues }));
  };

  const closeModalHandler = () => {
    closeModal("editClothQualityModal");
  };

  return (
    <Modal
      closable={true}
      visible={editClothQualityModal}
      okText="Add"
      maxwidth="568px"
      footer={false}
      onCancel={closeModalHandler}
      tittle="Edit Yarn Quality"
    >
      {/* <EditYarnQualityForm
        getClothQualities={getClothQualities}
        closeModal={closeModal}
      /> */}
      {isLoading ? <Loading /> : null}
      <StyledForm
        autocomplete="off"
        form={form}
        {...layout}
        name="basic"
        initialValues={formInitialValue}
        onValuesChange={onValuesChange}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
      >
        <Row
          gutter={{ xs: 0, sm: 48, md: 48, lg: 48 }}
          type="flex"
          justify="center"
        >
          <Col md={12} sm={18} xs={24}>
            <Form.Item
              label="Warp"
              name="warp"
              rules={[
                {
                  required: true,
                  message: "Please input Warp!",
                },
              ]}
            >
              <Input type="number" placeholder="Warp" />
            </Form.Item>
          </Col>
          <Col md={12} sm={18} xs={24}>
            <Form.Item
              label="Weft"
              name="weft"
              rules={[
                {
                  required: true,
                  message: "Please input weft!",
                },
              ]}
            >
              <Input type="number" placeholder="Weft" />
            </Form.Item>
          </Col>
          <Col md={12} sm={18} xs={24}>
            <Form.Item
              label="Reed"
              name="reed"
              rules={[
                {
                  required: true,
                  message: "Please input Reed!",
                },
              ]}
            >
              <Input type="number" placeholder="Reed" />
            </Form.Item>
          </Col>
          <Col md={12} sm={18} xs={24}>
            <Form.Item
              label="Pick"
              name="pick"
              rules={[
                {
                  required: true,
                  message: "Please input pick!",
                },
              ]}
            >
              <Input type="number" placeholder="Pick" />
            </Form.Item>
          </Col>
          <Col md={12} sm={18} xs={24}>
            <Form.Item
              label="Width"
              name="width"
              rules={[
                {
                  required: true,
                  message: "Please input width!",
                },
              ]}
            >
              <Input type="number" placeholder="Width" />
            </Form.Item>
          </Col>
          <Col md={12} sm={18} xs={24}>
            <Form.Item
              label="Type"
              name="type"
              rules={[
                {
                  required: true,
                  message: "Please input type!",
                },
              ]}
            >
              <Input placeholder="Type" />
            </Form.Item>
          </Col>
          {/* <Col md={12} sm={18} xs={24}></Col> */}
          <Col md={13} sm={18} xs={24}>
            <Row type="flex" justify="space-between">
              <Col sm={10}>
                <Button bg="#404E67" type="primary" htmlType="submit">
                  <Typography
                    text="Update"
                    as="h5"
                    noMargin
                    weight="bold"
                    align="center"
                    color="white"
                  />
                </Button>
              </Col>
              <Col sm={10}>
                <Button bg="#404E67" type="primary" onClick={closeModalHandler}>
                  <Typography
                    text="Cancel"
                    as="h5"
                    noMargin
                    weight="bold"
                    align="center"
                    color="white"
                  />
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
      </StyledForm>
    </Modal>
  );
};

export default AddYarnQuality;
